// extracted by mini-css-extract-plugin
export default {"title":"SubscriptionQA_title__REC3g","questions":"SubscriptionQA_questions__6kXwV","question":"SubscriptionQA_question__Laswk","contact":"SubscriptionQA_contact__nFP-P"};